import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Static teachers data
const staticTeachers = [
  {
    id: 1,
    name: "اسم المدرس",
    subject: "علوم",
    lessons: 32,
    students: "+50",
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    id: 2,
    name: "اسم المدرس",
    subject: "علوم",
    lessons: 32,
    students: "+50",
    image: "https://randomuser.me/api/portraits/men/34.jpg",
  },
  {
    id: 3,
    name: "اسم المدرس",
    subject: "علوم",
    lessons: 32,
    students: "+50",
    image: "https://randomuser.me/api/portraits/men/36.jpg",
  },
  {
    id: 4,
    name: "اسم المدرس",
    subject: "علوم",
    lessons: 32,
    students: "+50",
    image: "https://randomuser.me/api/portraits/men/34.jpg",
  },
];

// Async thunk for fetching teachers
export const fetchTeachers = createAsyncThunk(
  "teachers/fetchTeachers",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        return staticTeachers;
      }

      const response = await fetch(`${BASE_URL}/subjects/student_sub_subjects/0?page=1&per_page=200`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return staticTeachers;
      }

      // Handle the new API response structure
      let teachersData;
      if (data.data) {
        teachersData = data.data;
      } else if (data.result && data.result.data) {
        teachersData = data.result.data;
      } else if (data.result) {
        teachersData = data.result;
      } else {
        return staticTeachers;
      }

      return Array.isArray(teachersData) ? teachersData : staticTeachers;
    } catch (error) {
      console.error('Error fetching teachers:', error);
      return staticTeachers;
    }
  }
);

// Async thunk for fetching teachers by subject
export const fetchTeachersBySubject = createAsyncThunk(
  "teachers/fetchTeachersBySubject",
  async ({ subjectId, page = 1 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      
      if (!token) {
        return {
          teachers: staticTeachers,
          pagination: {
            total: staticTeachers.length,
            per_page: 10,
            current_page: 1,
            pages_count: 1
          }
        };
      }

      const response = await fetch(`${BASE_URL}/subjects/student_sub_subjects/${subjectId}?page=${page}&per_page=200`, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return {
          teachers: staticTeachers,
          pagination: {
            total: staticTeachers.length,
            per_page: 10,
            current_page: 1,
            pages_count: 1
          }
        };
      }

      // Handle the API response structure
      let teachersData = [];
      let paginationData = {};

      if (data.data) {
        teachersData = data.data;
        paginationData = {
          total: data.total || teachersData.length,
          per_page: data.per_page || 200,
          current_page: data.current_page || 1,
          pages_count: data.last_page || 1
        };
      } else if (data.result && data.result.data) {
        teachersData = data.result.data;
        paginationData = data.result.pagination || {};
      } else if (data.result) {
        teachersData = data.result;
        paginationData = data.pagination || {};
      } else {
        teachersData = staticTeachers;
        paginationData = {
          total: staticTeachers.length,
          per_page: 10,
          current_page: 1,
          pages_count: 1
        };
      }

      return {
        teachers: Array.isArray(teachersData) ? teachersData : staticTeachers,
        pagination: paginationData
      };
    } catch (error) {
      console.error('Error fetching teachers by subject:', error);
      return {
        teachers: staticTeachers,
        pagination: {
          total: staticTeachers.length,
          per_page: 10,
          current_page: 1,
          pages_count: 1
        }
      };
    }
  }
);

// Get child subject teachers for parent
export const getChildSubjectTeachers = createAsyncThunk(
  "teachers/getChildSubjectTeachers",
  async ({ childId, subjectId = 0, page = 1, perPage = 15 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/parent/child_sub_teachers/${subjectId}?page=${page}&per_page=${perPage}&child_id=${childId}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب مدرسين المادة");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Get all teachers for parent (without subject filter)
export const getAllTeachersForParent = createAsyncThunk(
  "teachers/getAllTeachersForParent",
  async ({ childId, page = 1, perPage = 15 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/parent/child_sub_teachers/0?page=${page}&per_page=${perPage}&child_id=${childId}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب المدرسين");
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

// Get subscribed teachers for parent
export const getSubscribedTeachersForParent = createAsyncThunk(
  "teachers/getSubscribedTeachersForParent",
  async ({ childId, page = 1, perPage = 15 }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      if (!token) {
        return rejectWithValue("التوكن مطلوب");
      }

      const response = await fetch(`${BASE_URL}/parent/child_sub_teachers/0?page=${page}&per_page=${perPage}&child_id=${childId}`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب المدرسين المشتركين");
      }

      // Filter only subscribed teachers
      if (data.data) {
        data.data = data.data.filter(teacher => teacher.is_subscribed === 1);
        data.total = data.data.length;
      }

      return data;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const initialState = {
  teachers: [],
  loading: false,
  error: null,
  pagination: null,
  currentSubject: null,
  currentPage: 1,
  childSubjectTeachers: null,
  childSubjectTeachersLoading: false,
  allTeachersForParent: null,
  allTeachersForParentLoading: false,
  subscribedTeachersForParent: null,
  subscribedTeachersForParentLoading: false,
};

const teachersSlice = createSlice({
  name: "teachers",
  initialState,
  reducers: {
    clearTeachersError: (state) => {
      state.error = null;
    },
    setCurrentSubject: (state, action) => {
      state.currentSubject = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeachers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeachers.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload;
      })
      .addCase(fetchTeachers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchTeachersBySubject.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeachersBySubject.fulfilled, (state, action) => {
        state.loading = false;
        state.teachers = action.payload.teachers;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchTeachersBySubject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // getChildSubjectTeachers reducers
      .addCase(getChildSubjectTeachers.pending, (state) => {
        state.childSubjectTeachersLoading = true;
        state.error = null;
      })
      .addCase(getChildSubjectTeachers.fulfilled, (state, action) => {
        state.childSubjectTeachersLoading = false;
        state.childSubjectTeachers = action.payload;
      })
      .addCase(getChildSubjectTeachers.rejected, (state, action) => {
        state.childSubjectTeachersLoading = false;
        state.error = action.payload;
      })
      // getAllTeachersForParent reducers
      .addCase(getAllTeachersForParent.pending, (state) => {
        state.allTeachersForParentLoading = true;
        state.error = null;
      })
      .addCase(getAllTeachersForParent.fulfilled, (state, action) => {
        state.allTeachersForParentLoading = false;
        state.allTeachersForParent = action.payload;
      })
      .addCase(getAllTeachersForParent.rejected, (state, action) => {
        state.allTeachersForParentLoading = false;
        state.error = action.payload;
      })
      // getSubscribedTeachersForParent reducers
      .addCase(getSubscribedTeachersForParent.pending, (state) => {
        state.subscribedTeachersForParentLoading = true;
        state.error = null;
      })
      .addCase(getSubscribedTeachersForParent.fulfilled, (state, action) => {
        state.subscribedTeachersForParentLoading = false;
        state.subscribedTeachersForParent = action.payload;
      })
      .addCase(getSubscribedTeachersForParent.rejected, (state, action) => {
        state.subscribedTeachersForParentLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearTeachersError, setCurrentSubject, setCurrentPage } = teachersSlice.actions;
export default teachersSlice.reducer; 